module.exports = __webpack_public_path__ + "img/Chart.771ce32d.png";